import React, { useState } from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import FormModal from '../components/FormModal';
import LoadingSpiner from '../components/LoadingSpiner';
import { capitalizeWords, formatPrice } from '../components/capitalizeFunction';
import { deleteButton } from '../components/AlerteModal';
import { useAllDepenses, useDeleteDepense } from '../../Api/queriesDepense';
import DepenseForm from './DepenseForm';

export default function DepenseListe() {
  const [form_modal, setForm_modal] = useState(false);
  const [formModalTitle, setFormModalTitle] = useState('Ajouter une Dépense');
  /**
   * OPTIMISATION PRO (Dépenses)
   *
   * Avant:
   * - Chargement complet + recherche JS + total calculé sur le front
   *
   * Maintenant:
   * - Mode backend `paged=1` (même endpoint)
   * - Recherche serveur `q`
   * - Pagination
   * - Totaux serveur `totals.sumTotalExpense`
   */
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const { mutate: deleteDepense, isDeleting } = useDeleteDepense();
  const [depenseToUpdate, setDepenseToUpdate] = useState(null);
  const [todayExpense, setTodayExpense] = useState(false);

  // Search State
  const [searchTerm, setSearchTerm] = useState('');

  // Debounce (évite spam réseau) + reset page
  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  React.useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setPage(1);
    }, 300);
    return () => clearTimeout(t);
  }, [searchTerm]);

  const { data: depenseData, isLoading, error } = useAllDepenses({
    paged: 1,
    page,
    limit,
    q: debouncedSearch,
    today: todayExpense ? 1 : 0,
  });

  // Données paginées (on garde le nom `filterSearchDepense` pour ne pas toucher le reste)
  const filterSearchDepense = depenseData?.items || [];
  const total = depenseData?.total ?? 0;
  const totalPages = depenseData?.totalPages ?? 1;

  // Total Expense
  const sumTotalExpense = depenseData?.totals?.sumTotalExpense ?? 0;

  // Ouverture de Modal Form
  function tog_form_modal() {
    setForm_modal(!form_modal);
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs title='Transaction' breadcrumbItem='Depense' />

          {/* -------------------------- */}
          <FormModal
            form_modal={form_modal}
            setForm_modal={setForm_modal}
            tog_form_modal={tog_form_modal}
            modal_title={formModalTitle}
            size='md'
            bodyContent={
              <DepenseForm
                depenseToEdit={depenseToUpdate}
                tog_form_modal={tog_form_modal}
              />
            }
          />

          {/* -------------------- */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id='depenseList'>
                    <Row className='g-4 mb-3'>
                      <Col className='col-sm-auto'>
                        <div className='d-flex gap-1'>
                          <Button
                            color='info'
                            className='add-btn'
                            id='create-btn'
                            onClick={() => {
                              setDepenseToUpdate(null);
                              tog_form_modal();
                            }}
                          >
                            <i className='fas fa-dollar-sign align-center me-1'></i>{' '}
                            Ajouter une Dépense
                          </Button>
                        </div>
                      </Col>

                      <Col className='col-sm'>
                        <div className='d-flex justify-content-sm-end gap-2 flex-wrap'>
                          {searchTerm !== '' && (
                            <Button
                              color='danger'
                              onClick={() => setSearchTerm('')}
                            >
                              <i className='fas fa-window-close'></i>
                            </Button>
                          )}
                          <div className='search-box me-4'>
                            <input
                              type='text'
                              className='form-control search border border-black rounded'
                              placeholder='Rechercher...'
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Pagination (en haut) */}
                        {!error && !isLoading && totalPages > 1 && (
                          <div className='d-flex justify-content-sm-end align-items-center gap-2 flex-wrap mt-2'>
                            <div
                              className='d-inline-flex gap-2'
                              role='group'
                              aria-label='Pagination depenses'
                            >
                              <Button
                                color='info'
                                className='shadow-sm'
                                disabled={page <= 1}
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                              >
                                <i className='bx bx-chevron-left'></i>
                              </Button>
                              <Button
                                color='primary'
                                className='shadow-sm'
                                disabled={page >= totalPages}
                                onClick={() =>
                                  setPage((p) => Math.min(totalPages, p + 1))
                                }
                              >
                                <i className='bx bx-chevron-right'></i>
                              </Button>
                            </div>
                            <span className='small fw-semibold text-dark'>
                              Page <span className='badge bg-primary'>{page}</span> /{' '}
                              <span className='badge bg-primary'>{totalPages}</span> ·{' '}
                              <span className='badge bg-info'>{total}</span> résultats
                            </span>
                            <div className='d-flex align-items-center gap-2'>
                              <span className='text-dark small fw-semibold'>
                                Par page
                              </span>
                              <select
                                className='form-select form-select-sm border border-primary'
                                style={{ width: 95 }}
                                value={limit}
                                onChange={(e) => {
                                  setLimit(Number(e.target.value));
                                  setPage(1);
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                              </select>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-around mt-4 flex-wrap'>
                      <h6 className=''>
                        Total Depensés:{' '}
                        <span className='text-danger'>
                          {formatPrice(sumTotalExpense)} F{' '}
                        </span>
                      </h6>
                      <div className='mx-4 d-flex gap-2 text-warning'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='filterToday'
                          onChange={() => setTodayExpense(!todayExpense)}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='filterToday'
                        >
                          Depense d'Aujourd'hui
                        </label>
                      </div>
                    </div>
                    {error && (
                      <div className='text-danger text-center'>
                        Erreur de chargement des données
                      </div>
                    )}
                    {isLoading && <LoadingSpiner />}

                    <div className='table-responsive table-card mt-3 mb-1'>
                      {filterSearchDepense?.length === 0 && (
                        <div className='text-center text-mutate'>
                          Aucune Dépense trouvée !
                        </div>
                      )}
                      {!error &&
                        !isLoading &&
                        filterSearchDepense.length > 0 && (
                          <table
                            className='table align-middle table-nowrap'
                            id='depenseTable'
                          >
                            <thead className='table-light'>
                              <tr className='text-center '>
                                <th data-sort='date' style={{ width: '50px' }}>
                                  Date de dépense
                                </th>

                                <th className='sort' data-sort='motif'>
                                  Motif de Dépense
                                </th>
                                <th className='sort' data-sort='totaAmount'>
                                  Somme Dépensé
                                </th>

                                <th className='sort' data-sort='action'>
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody className='list form-check-all'>
                              {filterSearchDepense?.length > 0 &&
                                filterSearchDepense?.map((depense) => (
                                  <tr key={depense._id} className='text-center'>
                                    <td>
                                      {new Date(
                                        depense.dateOfDepense
                                      ).toLocaleDateString()}{' '}
                                    </td>

                                    <td className='text-wrap'>
                                      {capitalizeWords(depense.motifDepense)}
                                    </td>

                                    <td className='text-danger'>
                                      {formatPrice(depense.totalAmount)}
                                      {' F '}
                                    </td>

                                    <td>
                                      <div className='d-flex gap-2'>
                                        <div className='edit'>
                                          <button
                                            className='btn btn-sm btn-success edit-item-btn'
                                            onClick={() => {
                                              setFormModalTitle(
                                                'Modifier les données'
                                              );
                                              setDepenseToUpdate(depense);
                                              tog_form_modal();
                                            }}
                                          >
                                            <i className='ri-pencil-fill text-white'></i>
                                          </button>
                                        </div>
                                        {isDeleting && <LoadingSpiner />}
                                        {!isDeleting && (
                                          <div className='remove'>
                                            <button
                                              className='btn btn-sm btn-danger remove-item-btn'
                                              data-bs-toggle='modal'
                                              data-bs-target='#deleteRecordModal'
                                              onClick={() => {
                                                deleteButton(
                                                  depense._id,
                                                  `depense de ${depense.totalAmount} F
                                                   `,
                                                  deleteDepense
                                                );
                                              }}
                                            >
                                              <i className='ri-delete-bin-fill text-white'></i>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
